import { useRef } from "react";

export const MAX_AMOUNT = 999999999999;
const NBSP = "\u00A0";

/** Affichage avec espaces insécables de milliers ; la valeur remontée reste le nombre brut. */
export function groupDigits(digits) {
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
}

export function fmtAmountInput(raw) {
  const digits = String(raw ?? "").replace(/\D/g, "").replace(/^0+(?=\d)/, "");
  return digits ? groupDigits(digits) : "";
}

/**
 * Champ de saisie de montant ou de quantité.
 * - n'accepte que des chiffres (lettres, symboles et collage « 1,000,000 » nettoyés) ;
 * - affiche 1 000 000 000 pendant la frappe, envoie 1000000000 ;
 * - garde le curseur à sa place quand on corrige un chiffre au milieu ;
 * - clavier numérique et police ≥ 16 px sur téléphone.
 */
export function AmountInput({ value, onChange, onOverflow, className = "", max = MAX_AMOUNT, ...rest }) {
  const ref = useRef(null);

  const handle = (e) => {
    const el = e.target;
    const before = el.value;
    const caret = el.selectionStart ?? before.length;
    const digitsBeforeCaret = before.slice(0, caret).replace(/\D/g, "").length;
    let digits = before.replace(/\D/g, "").replace(/^0+(?=\d)/, "");
    if (digits.length > String(max).length) {
      digits = digits.slice(0, String(max).length);
      onOverflow?.(`Montant maximum : ${groupDigits(String(max))}`);
    }
    if (digits && Number(digits) > max) {
      digits = String(max);
      onOverflow?.(`Montant maximum : ${groupDigits(String(max))}`);
    }
    const formatted = digits ? groupDigits(digits) : "";
    onChange(digits);
    requestAnimationFrame(() => {
      const node = ref.current;
      if (!node) return;
      let seen = 0;
      let pos = formatted.length;
      for (let i = 0; i < formatted.length; i += 1) {
        if (/\d/.test(formatted[i])) {
          seen += 1;
          if (seen === digitsBeforeCaret) { pos = i + 1; break; }
        }
      }
      if (digitsBeforeCaret === 0) pos = 0;
      node.setSelectionRange(pos, pos);
    });
  };

  return (
    <input
      ref={ref}
      type="text"
      inputMode="numeric"
      autoComplete="off"
      className={`kinput amount-input ${className}`}
      value={fmtAmountInput(value)}
      onChange={handle}
      {...rest}
    />
  );
}
